export const bovineTypes = {
    TOURO: 1,
    BOI: 2,
    VACA: 3,
    BEZERRO: 4,
    BEZERRA: 5,
    NULIPARA: 6,
    PRIMIPARA: 7,
    MULTIPARA: 8,
};

export const bovineColors = {
    [bovineTypes.TOURO]: { background: '#000', color: 'white' },
    [bovineTypes.BOI]: { background: '#9A7A54', color: 'white' },
    [bovineTypes.VACA]: { background: '#FFE600', color: 'black' },
    [bovineTypes.BEZERRO]: { background: '#0085FF', color: 'white' },
    [bovineTypes.BEZERRA]: { background: '#FF0000', color: 'white' },
    [bovineTypes.NULIPARA]: { background: '#FFE600', color: 'black' },
    [bovineTypes.PRIMIPARA]: { background: '#FFE600', color: 'black' },
    [bovineTypes.MULTIPARA]: { background: '#FFE600', color: 'black' },
};

export const bovineRootTypes = [
    bovineTypes.VACA,
    bovineTypes.NULIPARA,
    bovineTypes.PRIMIPARA,
    bovineTypes.MULTIPARA,
];

export const isTypeBovineRoot = (typeId) => bovineRootTypes.includes(typeId);
